module.exports = "<!-- <app-combine></app-combine> -->\n<!-- <div [innerHTML]=\"html\"></div> -->\n\n<iframe [src]=\"urlSafe\" frameborder=\"0\" width=\"100%\" style=\"height: 100vh;position: fixed;\" *ngIf=\"!currentUser\">\n</iframe>\n\n<!-- <app-medicolegal *ngIf=\"currentUser\"></app-medicolegal> -->"


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_welcome/home/home.component.html
// module id = ../../../../../src/app/_components/components_welcome/home/home.component.html
// module chunks = main